import React from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

// css
import styles from "./addForm.module.scss";

const AddClientPrivate = () => {
  return (
    <>
      <section className={`${styles.addForm} position-relative py-4 addForm`}>
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="pageHead pb-3">
                <h6 className="m-0 fw-bold themeBlue">Add New Clients</h6>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Form>
                <div
                  className="py-3"
                  style={{ borderTop: "1px solid #41a2a84d" }}
                >
                  <Row>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Last Name
                      </label>
                      <input
                        type="text"
                        placeholder="e.g Smith"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        First Name
                      </label>
                      <input
                        type="text"
                        placeholder="e.g John"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        DOB
                      </label>
                      <input
                        type="date"
                        placeholder="e.g John"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Parent Name
                      </label>
                      <input
                        type="text"
                        placeholder="e.g Smith"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Funding Source
                      </label>
                      <Form.Select
                        className={`${styles.formControl} form-control`}
                        aria-label="Default select example"
                      >
                        <option>Please select Source</option>
                        <option value="1">One</option>
                        <option value="2">Two</option>
                        <option value="3">Three</option>
                      </Form.Select>
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        Start Date
                      </label>
                      <input
                        type="date"
                        placeholder="Please Enter"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                    <Col md="4" sm="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label themeBlue fw-bold mb-0"
                      >
                        End Date
                      </label>
                      <input
                        type="date"
                        placeholder="Please Enter"
                        className={`${styles.formControl} form-control`}
                      />
                    </Col>
                  </Row>
                </div>
                <Row className="mt-5 ">
                  <Col className="my-2" lg="12">
                    <div
                      className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
                      style={{ borderTop: "1px solid #41a2a84d" }}
                    >
                      <Button className="d-flex align-items-center justify-content-center commonBtn">
                        Save
                      </Button>
                      <Button className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent">
                        Cancel
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddClientPrivate;
